import * as React from 'react';
import { isTabbable } from 'tabbable';
import whatInput from 'what-input';
const InputContext = React.createContext({
    input: 'initial',
});
const InputProvider = (props) => {
    const [input, setInput] = React.useState('initial');
    React.useEffect(() => {
        whatInput.registerOnChange(
        /* istanbul ignore next */ nextInput => {
            setInput(prevInput => {
                if (prevInput === 'keyboard' && nextInput === 'mouse' && document.activeElement && isTabbable(document.activeElement)) {
                    /**
                     * Some screen readers, like NVDA, trigger a mouse click when tabbable elements are activated via Space/Enter.
                     * This causes what-input to trigger a change event.
                     * In components that depend on "automatic dynamic trigger", e.g. where mouse input always has hover listeners and keyboard input has click listeners (for example: Tooltip, HeaderNav), this results as the toggleable element not opening at all when using NVDA.
                     */
                    return prevInput;
                }
                return nextInput;
            });
        }, 'intent');
        setInput(whatInput.ask('intent'));
        return () => whatInput.unRegisterOnChange(setInput);
    }, []);
    return React.createElement(InputContext.Provider, { value: { input } }, props.children);
};
export { InputProvider as default, InputContext };
